import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  pageTitle: string = 'Users';

  showCreate: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  showCreateForm() {
    this.showCreate = true;
  }
}
